import {useMemo} from 'react';
import {useSelector} from 'react-redux';
import {loadedPresentationSelector} from '../../../../../store/selectors/presentation.selectors';
import {IElementQuestionnaire} from '../../../../../incase-domain/elements/base/questionElementBase';
import {ISlide} from '../../../../../incase-domain/slide';

interface LinkedQuestionElement {
    questionSlide: ISlide | undefined;
    actualQuestionElement: IElementQuestionnaire | null;
}

export function useLinkedQuestionElement(questionElementId: string | undefined): LinkedQuestionElement {
    const loadedPresentation = useSelector(loadedPresentationSelector);

    const questionSlide = useMemo(() => {
        if (!questionElementId || !loadedPresentation?.slides) {
            return undefined;
        }
        return loadedPresentation.slides.find((slide) => slide.elements?.some((el) => 'id' in el && el.id === questionElementId));
    }, [questionElementId, loadedPresentation?.slides]);

    const actualQuestionElement = useMemo(() => {
        if (!questionElementId || !questionSlide?.elements) {
            return null;
        }
        return (
            (questionSlide.elements.find((el) => 'id' in el && el.id === questionElementId) as IElementQuestionnaire | undefined) || null
        );
    }, [questionElementId, questionSlide]);

    return {questionSlide, actualQuestionElement};
}
